const DEFAULT_LOCAL_BACKEND_URL = 'http://localhost:8069';

const normalizeOrigin = (value) => (value || '').trim().replace(/\/+$/, '');

const rawBackendUrl = normalizeOrigin(process.env.REACT_APP_BACKEND_URL);

export const useLocalProxy =
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_USE_LOCAL_PROXY !== 'false';

export const backendOrigin = useLocalProxy
  ? ''
  : (rawBackendUrl || DEFAULT_LOCAL_BACKEND_URL);

export const apiBaseUrl = useLocalProxy
  ? '/api/v1'
  : `${backendOrigin}/api/v1`;

export const resolveBackendUrl = (path = '') => {
  if (!path) {
    return backendOrigin || DEFAULT_LOCAL_BACKEND_URL;
  }

  if (
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('data:')
  ) {
    return path;
  }

  if (!path.startsWith('/')) {
    return path;
  }

  return backendOrigin ? `${backendOrigin}${path}` : path;
};

export const getBackendHost = () => {
  if (backendOrigin) {
    return new URL(backendOrigin).hostname;
  }

  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }

  return 'localhost';
};
